import $ from 'jquery';
import { showAjaxLoader, hideAjaxLoader } from '@invia/web-library/helpers/ajaxLoader';


export const init = () => {
	var $loadBtn = $('#btn-load-offers');

	$loadBtn.click(function (e) {
		e.preventDefault();

		var searchParams = $('#career_search_form').inviaToJson();

		var $jobList = $('.c-jobs__list').last();
		var offersCount = $jobList.find('> li').length;

		$.ajax({
			url: '/direct/corporate_career/ajax-load-offers/',
			data: $.extend(searchParams, {
				offset: offersCount,
				alternativeOffersList: $jobList.hasClass('alternative-offers'),
			}),
			success: function (data) {
				if (data.html) {
					var $lastOffer = $jobList.find('> li').last();
					var topOffset = $lastOffer.offset().top + $lastOffer.height();

					$jobList.append(data.html);
					//$('body, html').scrollTop(topOffset, 500);
					$('body, html').animate({
						scrollTop: topOffset,
					}, 500);
				}

				// uz neni co nacitat
				if (data.offersCount < data.showOffersCount) {
					$loadBtn.hide();
				}
			},
			beforeSend: showAjaxLoader,
			complete: hideAjaxLoader,
		});
	});
};
